import { defineComponent as _defineComponent } from 'vue'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const __default__ = require('@nuxtjs/composition-api').defineComponent({
  name: 'SearchPage',
  head: {},
});

import { computed, useRoute, useContext, useMeta } from '@nuxtjs/composition-api';
import { MetaInfo } from 'vue-meta';
import KeywordSearchPage from '~/components/search/KeywordSearchPage.vue';
import { convertToTitleCase } from '~/utils/formatStrings';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { $hrefLangsPage } = useContext();
const $route = useRoute();
const keyword = computed(() => $route.value.params?.keyword || '');
const query = computed(() =>
  Array.isArray($route.value.query.query) ? $route.value.query.query[0] : $route.value.query.query
);

const keywordTitleCase = computed(() => convertToTitleCase(keyword.value || query.value || ''));

const metaInfo: MetaInfo = {
  title: `${keywordTitleCase.value || 'Search'}`,
  meta: [
    { hid: 'title', name: 'title', content: `${keywordTitleCase.value || 'Search'}` },
    {
      hid: 'description',
      name: 'description',
      content: `"${keywordTitleCase.value}" teaching resources for those 'aha' moments`,
    },
    { hid: 'og-title', property: 'og:title', content: 'Search' },
    {
      httpEquiv: 'cache-control',
      content: 'max-age=0, no-store',
    },
  ],
  link: $hrefLangsPage($route.value),
};
useMeta(metaInfo);

return { __sfc: true,$hrefLangsPage, $route, keyword, query, keywordTitleCase, metaInfo, KeywordSearchPage }
}

})